var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActiveAudits(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1047_19224",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 21.5V2.5H2.5V21.5H21.5Z",
    fill: "white",
    stroke: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1047_19224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6432 3.7216V17.6258C17.6432 18.0446 17.3038 18.384 16.885 18.384H14.6526C14.6526 16.9188 13.4651 15.7309 11.9999 15.7309C10.5347 15.7309 9.34679 16.9188 9.34679 18.384H7.11438C6.69602 18.384 6.35657 18.0446 6.35657 17.6258V3.7216C6.35657 3.30324 6.69602 2.96379 7.11438 2.96379H16.885C17.3038 2.96379 17.6432 3.30324 17.6432 3.7216Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8035 10.7438L21.5929 7.12546C21.6761 6.74382 21.4343 6.36683 21.0526 6.28363L17.6433 5.53988V17.6254C17.6433 18.0442 17.3038 18.3836 16.8851 18.3836H14.6527C14.6527 18.8027 14.5554 19.1992 14.382 19.5516L17.987 20.3379C18.3683 20.4211 18.7453 20.1793 18.8284 19.7976L20.0711 14.1015",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.34761 18.4531C9.34722 18.4301 9.34682 18.407 9.34682 18.3836H7.1148C6.69606 18.3836 6.3566 18.0441 6.3566 17.6254V5.53988L2.94724 6.28363C2.5656 6.36683 2.32381 6.74378 2.40701 7.12546L5.17145 19.7976C5.25466 20.1793 5.63161 20.4211 6.01285 20.3379L9.61753 19.5515C9.45346 19.2188 9.35776 18.8469 9.34761 18.4531Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6527 18.3834C14.6527 19.8486 13.4649 21.0364 11.9998 21.0364C10.5346 21.0364 9.3468 19.8486 9.3468 18.3834C9.3468 16.9182 10.5346 15.7305 11.9998 15.7305C13.4649 15.7305 14.6527 16.9182 14.6527 18.3834Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0104 18.5862L11.6756 19.2515L13.0786 17.8485",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0012 5.69604H15.2017",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.59631 13.6433H13.0862",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.59631 8.34546H15.2017",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.59631 10.9939H15.2017",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveAudits);
export default __webpack_public_path__ + "static/media/activeAudits.ce4b47a0d14bea8b0d7665b5bb811034.svg";
export { ForwardRef as ReactComponent };